
var cmsPrivacy = vueIfExists({
  el: '#cms-privacy',
  mounted: function() {
  	win.decodeEmails();
  }
});
